import { memo as Memo, useRef, useEffect, useCallback, useMemo } from 'react';
import { gsap } from 'gsap';

//* SVGs
import { AwardsItem1, AwardsItem2, AwardsItem3, AwardsItem4 } from '../AwardsSvg';

//* Components
import CustomLink from '../../CustomLink';
import Text from '../../Text';

const AwardsBlack = Memo(({ ind, anime, ...item }) => {
	//! Refs
	const cardRef = useRef(null);
	const scaleRef = useRef(null);
	const textRef = useRef(null);

	//! Static Variables
	const time = useMemo(() => [0.5, 0.7, 0.8, 0.9], []);

	useEffect(() => {
		if (!scaleRef.current) return;

		let scale1 = 0,
			borderWidth = 400,
			scale2 = 2.1;

		if (anime) {
			scale1 = 1;
			borderWidth = 6;
			scale2 = 1;
		}

		//! tweens
		gsap.to(scaleRef.current, { duration: time[ind], scale: scale1 });
		gsap.to(scaleRef.current.children[0], { duration: time[ind], borderWidth });
		gsap.to(scaleRef.current.children[1], { duration: time[ind], scale: scale2 });

		//! clean
		return () => {
			gsap.killTweensOf(scaleRef.current);
			if (scaleRef.current) {
				gsap.killTweensOf(scaleRef.current.children[0]);
				gsap.killTweensOf(scaleRef.current.children[1]);
			}
		};
	}, [anime, ind, time]);

	//! Mouse Over
	const mouseOver = useCallback((e) => {
		const el = e.currentTarget;
		const rect = el.getBoundingClientRect();
		const relX = (e.pageX || e.clientX + window.scrollX) - rect.left;

		const ratio = (relX - rect.width / 2) / rect.width;

		gsap.to(cardRef.current, { duration: 1, x: ratio * -90, rotation: 3 });
		gsap.to(textRef.current, { duration: 1, x: ratio * 60 });
	}, []);

	//! Mouse Out
	const mouseOut = useCallback(() => {
		gsap.to(cardRef.current, { duration: 1, x: 0, rotation: 0 });
		gsap.to(textRef.current, { duration: 1, x: 0 });
	}, []);

	//! clean
	useEffect(() => {
		return () => {
			gsap.killTweensOf([cardRef.current, textRef.current]);
		};
	}, []);

	//! SVG Element
	const SVGEl = useMemo(() => {
		const index = ind + 1;
		return index === 1 ? AwardsItem1 : index === 2 ? AwardsItem2 : index === 3 ? AwardsItem3 : AwardsItem4;
	}, [ind]);

	return (
		<CustomLink
			external
			ref={scaleRef}
			url={item.award_url}
			className='crCircle awardsItemColumn-black'>
			<div className='border' />

			<div
				onMouseOut={mouseOut}
				onMouseMove={mouseOver}
				className='awardsItemCont'>
				<div
					ref={cardRef}
					className='awardsItemIcon'>
					<SVGEl />
				</div>

				<div
					ref={textRef}
					className='awardsItemInfo'>
					<Text className='h6 font-poppins font-medium awardName'>
						{item.title}&nbsp;{item.year}
					</Text>

					<Text className='p-m font-anonymous font-regular awardsItemDescription'>{item.description}/</Text>

					<Text className='p-m font-poppins font-italic'>{item.project_url.replace(/(^\w+:|^)\/\//, '')}</Text>
				</div>
			</div>
		</CustomLink>
	);
});

export default AwardsBlack;
